import { useEffect, useState } from "react";
import { Divider, Loader, Message, Modal, useToaster } from "rsuite";
import { gatewayCRUD } from "../../actions/gateway";
import ReactJson from "react-json-view";

export const ERMSFullData = (props) => {
  const { open, setOpen, dataId } = props;
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const toaster = useToaster();

  useEffect(() => {
    if (dataId) {
      setLoading(true);
      setTimeout(() => {
        gatewayCRUD
          .loadSingleERMSData(dataId)
          .then((resp) => {
            setData(resp.data);
          })
          .catch((error) => {
            toaster.push(
              <Message type="error" showIcon header={"Error"} closable>
                <p className="h6 fs-14">
                  <span className="fw-bold">Ooops...!</span>
                  <span className="text-dark">Something went wrong</span>.
                </p>
              </Message>,
              { placement: "bottomEnd", duration: 7000 }
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }, 500);
    }
  }, [dataId]);

  return (
    <>
      <Modal open={open} onClose={() => setOpen(false)} size="lg">
        <Modal.Header>
          <Modal.Title>
            <span className="fw-bold h6 fs-20">Data Details</span>
          </Modal.Title>
        </Modal.Header>
        <Divider />
        <Modal.Body>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <ReactJson src={data} theme="monokai" iconStyle="triangle" />
              </div>
            </div>
          </div>
        </Modal.Body>
        <Divider style={{ marginTop: -10 }} />
        <Modal.Footer>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-6 col-sm-12 d-flex justify-content-start"></div>
              <div className="col-md-6 col-sm-12 d-flex justify-content-end">
                <button
                  onClick={() => setOpen(false)}
                  className="btn btn-sm btn-soft-danger me-3"
                >
                  <span className="bi bi-x-circle"></span> Close
                </button>
              </div>
            </div>
          </div>
        </Modal.Footer>
        {loading && (
          <Loader
            size="lg"
            speed="slow"
            center
            backdrop
            style={{ color: "orange" }}
            content="Please wait..."
            vertical
          />
        )}
      </Modal>
    </>
  );
};
